import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Button,
  TextField,
  TablePagination,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { fetchTodayGroupCollections } from "../../services/loanService";
import moment from "moment";

const columns = [
  { id: "slNo", label: "SL.NO", minWidth: 50 },
  { id: "groupName", label: "GROUP NAME", minWidth: 200 },
  { id: "groupCode", label: "GROUP CODE", minWidth: 100 },
  { id: "groupLeaderNumber", label: "GROUP LEADER NUMBER", minWidth: 150 },
  { id: "agent", label: "AGENT", minWidth: 100 },
  { id: "collectionDay", label: "COLLECTION DAY", minWidth: 150 },
  { id: "totalLoanAmount", label: "TOTAL LOAN AMOUNT", minWidth: 150 },
  { id: "disbursedAmount", label: "DISBURSED AMOUNT", minWidth: 150 },
  { id: "totalMembers", label: "TOTAL MEMBERS", minWidth: 100 },
];

const GroupTable = () => {
  const navigate = useNavigate();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [groupLoans, setGroupLoans] = useState();

  // When rendering, you can format dates as:
  // const formattedDate = moment(row.startDate).format("DD-MM-YYYY");

  const fetchData = async () => {
    // Fetch loan data from API (pagination and search term passed)
    console.log("im called");
    const collections = await fetchTodayGroupCollections();
    console.log("collections", collections);
    setGroupLoans(collections);
    // setTotalLoanCount(collections.totalCollectedLoans); // Update total loan count for pagination
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <>
      <TableContainer component={Paper} sx={{ borderRadius: "8px" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            m: 2,
          }}
        >
          <Button
            variant="contained"
            size="small"
            sx={{
              py: 0.5,
              textTransform: "capitalize",
              fontSize: "16px",
              borderRadius: "8px",
            }}
            onClick={() => navigate("/group-pigmy/create-group-pigmy")}
          >
            Create New Group
          </Button>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search..."
            // value={searchTerm}
            // onChange={handleSearchChange}
            sx={{ py: 0.5, backgroundColor: "#fff", borderRadius: 8 }}
          />
        </Box>

        <Table stickyHeader aria-label="group table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align="left"
                  style={{
                    minWidth: column.minWidth,
                    color: "#5252ff",
                    backgroundColor: "#fff",
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {groupLoans
              ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              ?.map((row, index) => (
                <TableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={row._id || index}
                >
                  <TableCell align="left" key={`${row._id}-slNo`}>
                    {index + 1 + page * rowsPerPage}
                  </TableCell>
                  <TableCell align="left" key={`${row._id}-loanCode`}>
                    {row?.groupName}
                  </TableCell>

                  <TableCell align="left" key={`${row._id}-loanCode`}>
                    {row?.loanCode}
                  </TableCell>
                  <TableCell align="left" key={`${row._id}-loanCode`}>
                    {row?.groupLeaderPhoneNumber}
                  </TableCell>
                  <TableCell align="left" key={`${row._id}-loanAmount`}>
                    Agent
                  </TableCell>
                  <TableCell align="left" key={`${row._id}-interest`}>
                    {row?.collectionDay}
                  </TableCell>
                  <TableCell align="left" key={`${row._id}-interest`}>
                    {row?.loanAmount}
                  </TableCell>
                  {/* <TableCell align="left" key={`${row._id}-startDate`}>
                    {moment(row?.startDate).format("DD-MM-YYYY")}
                  </TableCell>
                  <TableCell align="left" key={`${row._id}-endDate`}>
                    {moment(row?.endDate).format("DD-MM-YYYY")}
                  </TableCell> */}
                  {/* <TableCell align="left" key={`${row._id}-status`}>
                    {row?.status}
                  </TableCell> */}
                  <TableCell align="left" key={`${row._id}-status`}>
                    {row?.disbursedAmount}
                  </TableCell>

                  <TableCell align="left" key={`${row._id}-status`}>
                    {row?.users.length}
                  </TableCell>
                  {/* Add more TableCell components as needed for other fields */}
                </TableRow>
              ))}
          </TableBody>
        </Table>
        {/* <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{ color: "#000" }}
        /> */}
      </TableContainer>
    </>
  );
};

export default GroupTable;
